
import { Box, Button, Typography } from "@mui/material";

import { useState } from "react";
import CustomPaginationActionsTable from "./paginationTable";
import PaymentHistory from "./paymentHistory";

export default function ManageSubscription() {

    const [plans, setPlans] = useState("active_plans")


    const planOptions = [
        { id: "active_plans", label: "Active Plans" },
        { id: "inactive_plans", label: "Inactive Plans" },
        { id: "payment_history", label: "Payment History" },
    ];

    const buttonStyle = (id: string) => ({
        bgcolor: plans === id ? "primary.main" : "#fafafa",
        color: plans === id ? "white" : "primary.main",
        border: "1px solid #e5e5e5",
        py: "2px",
        px: "10px",
        borderRadius: "5px",
        cursor: "pointer",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    });




    return (

        <Box sx={{ padding: "30px", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", mx: "30px", my: "100px", borderRadius: "12px" }}>
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 600,
                    color: "primary.main",
                }}
            >
                Manage Subscriptions
            </Typography>

            

            <Box sx={{ my: "20px", display: "flex", alignItems: "center", gap: "5px" }}>

                {planOptions.map(({ id, label }) => (
                    <Button
                        key={id}
                        id={id}
                        sx={buttonStyle(id)}
                        onClick={(event) => setPlans(event.currentTarget.id)}
                    >
                        {label}
                    </Button>
                ))}

            </Box>

            <Box sx={{ mt: "60px" }}>
                {plans === "active_plans" && <CustomPaginationActionsTable data={[]} />}
                {plans === "inactive_plans" && <CustomPaginationActionsTable data={[]} />}
                {plans === "payment_history" && <PaymentHistory />}
            </Box>
        </Box>
    )
}
